export const QUERY_STALE_TIME = {
  standard: 5 * 60 * 1000,
  stable: Infinity
} as const;
